import {useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import Logger from '@nl/logger';
import {event, EVENT_TYPES} from '../utils/event';

function useFavorite() {
	const {initialized} = useSelector((state) => state.client, shallowEqual);

	// Initialization
	useEffect(() => {
		const addRemoveFavPlayerCallback = (isAdd, playerInfo, allFavPlayers = []) => {
			if (window.g_NLAAUI) {
				try {
					const myFavPlayers = allFavPlayers.map(({playerId, playerName, followed, favorited}) => ({
						id: playerId,
						f: playerName.split(' ')[0],
						l: playerName.split(' ')[1],
						followed,
						favorited,
					}));
					window.g_NLAAUI.getNBAClient().updateFavoritePlayers(myFavPlayers);
				} catch (e) {
					Logger.error('useNLAAUITracker: g_NLAAUI.getNBAClient().updateFavoritePlayers error!', e);
				}
			} else {
				Logger.error('useNLAAUITracker: window.g_NLAAUI doesn\'t exist');
			}
		};
		const addRemoveFavTeamCallback = (isAdd, teamInfo, allFavTeams = []) => {
			if (window.g_NLAAUI) {
				try {
					const myFavTeams = Object.values(allFavTeams).map((
							{
								teamId, teamTriCode, favorited, followed,
							},
					) => ({
						id: teamId,
						code: teamTriCode,
						followed,
						favorited,
					}));
					window.g_NLAAUI.getNBAClient().updateFavoriteTeams(myFavTeams);
				} catch (e) {
					Logger.error('useNLAAUITracker: g_NLAAUI.getNBAClient().updateFavoriteTeams error! ', e);
				}
			} else {
				Logger.error('useNLAAUITracker: window.g_NLAAUI doesn\'t exist');
			}
		};
		if (initialized) {
			event.on(EVENT_TYPES.ADD_FAVORITE_PLAYER, addRemoveFavPlayerCallback)
					.on(EVENT_TYPES.REMOVE_FAVORITE_PLAYER, addRemoveFavPlayerCallback)
					.on(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavTeamCallback)
					.on(EVENT_TYPES.REMOVE_FAVORITE_TEAM, addRemoveFavTeamCallback);
		}
		return () => {
			if (initialized) {
				event.off(EVENT_TYPES.ADD_FAVORITE_PLAYER, addRemoveFavPlayerCallback)
						.off(EVENT_TYPES.REMOVE_FAVORITE_PLAYER, addRemoveFavPlayerCallback)
						.off(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavTeamCallback)
						.off(EVENT_TYPES.REMOVE_FAVORITE_TEAM, addRemoveFavTeamCallback);
			}
		};
	}, [initialized]);
}

export default useFavorite;
